// extracted by mini-css-extract-plugin
export var orderSummary = "_qu-0";
export var showMoreLessButton = "_qu-1";